import ModalComponent from "@/components/ui/modal";
import { Text, Flex } from "@chakra-ui/react";
import { useI18n } from "@/hooks/useI18n";
import { useMedia } from "@/hooks/useMedia";
import { BXButton } from "@/styles";

const DeactivateAccountModal = ({ show, onOK, onCancel, itemInfo }) => {
  const { t } = useI18n();
  const { isMobile } = useMedia();

  return (
    <ModalComponent
      isShow={show}
      style={{ width: !isMobile ? "400px" : "calc(100% - 30px)" }}
    >
      <Flex
        flexDirection={"column"}
        alignItems={"flex-start"}
        p={["50px 20px"]}
        justifyContent={"center"}
      >
        <Text mt={"20px"} fontWeight={600} fontSize={"16px"}>
          {t("vAeqeVWtpVywOzVUYfuv").replace("$s", itemInfo?.email)}
        </Text>
        <Text color={"#7B7C8F"} fontSize={"14px"} mt={"20px"}>
          {t("PLWcAjJpcpPoIQiCcq")}
        </Text>
        <Flex justifyContent={"space-between"} mt={"30px"} w={"100%"}>
          <BXButton
            flex={"1"}
            className="cancel"
            onClick={() => {
              onCancel && onCancel();
            }}
          >
            {t("UNForxvjDLCZdGrmWkX")}
          </BXButton>
          <BXButton
            ml={"10px"}
            flex={"2.5"}
            onClick={() => {
              onOK && onOK();
            }}
          >
            {t("AQrCocFqoKoYieUnT")}
          </BXButton>
        </Flex>
      </Flex>
    </ModalComponent>
  );
};

export default DeactivateAccountModal;
